export default __webpack_public_path__ + "static/media/turmeric.890ccdb5.png";